/* eslint-disable no-console */
import { put, call, takeLeading, takeEvery, select, delay } from "redux-saga/effects";
import {
  relevantSearchFacetAggregateRequest,
  relevantSearchSchemeRequest,
} from "@/shared/api/relevantSearch/RelevantSearchAPI";
import {
  relevantSearchActions,
  relevantSearchActionConstants,
} from "@/store/actions";
import {getSuggestionsPopupRequest} from "@/shared/api/suggestions/suggestions";

const TAG = "RelevantSearchSaga_";


function* fetchRelevantSearchSchemeAsync() {
  try {
    const { scheme } = yield select((state) => state.relevantSearch);

    if (scheme.length === 0) {
      const data = yield call(relevantSearchSchemeRequest);
      if (data) {
        const languages = data.sections.map((v) => v.language_code);
        const unicLanguages = [...new Set(languages)];
        yield put(
          relevantSearchActions.fetchRelevantSearchSchemeSuccess(data.sections, unicLanguages),
        );
      }
    }
  } catch (error) {
    console.log(TAG + "fetchRelevantSearchSchemeAsync", error);
  }
}

function* fetchRelevantSearchFacetAggregateAsync(action) {
  yield delay(1000);
  try {
    if (action.data.lang) {
      let results = yield call(relevantSearchFacetAggregateRequest, action.data);
      if (!results) {
        results = {};
      }
      const resultsSuggestions = yield call(
        getSuggestionsPopupRequest, action.data.query, action.data.lang
      );
      if (resultsSuggestions?.suggestions?.length > 0) {
        results["egw_search:009"] = { facets: { suggestions: resultsSuggestions.suggestions } };
      } else {
        results["egw_search:009"] = { facets: { suggestions: [] } };
      }
      if (results) {
        yield put(
          relevantSearchActions.fetchRelevantSearchFacetAggregateSuccess(results, action.data.lang),
        );
      }
    }
  } catch (error) {
    console.log(TAG + "fetchRelevantSearchFacetAggregateAsync", error);
  }
}

export default function* relevantSearch() {
  yield takeLeading(
    relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_SCHEME,
    fetchRelevantSearchSchemeAsync,
  );
  yield takeEvery(
    relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_FACET_AGGREGATE,
    fetchRelevantSearchFacetAggregateAsync,
  );
}
